module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/extension-worker/extension-worker.02dfc9d28a602f71fcf4.js");
};